import { useSortable } from '@dnd-kit/sortable';
import { IconButton } from '@foam/buoy/src/components/IconButton/IconButton';

export const DragHandle = ({ id }: { id: string }) => {
  const { listeners, isDragging } = useSortable({ id });

  return (
    <IconButton
      {...listeners}
      variant="tertiary"
      aria-label="Move content item"
      size="md"
      icon="MoveDots"
      disabled={isDragging}
      onClick={(e) => e.stopPropagation()}
      track-id="media-kit-content-reorder-btn"
    />
  );
};
